import { Injectable } from '@angular/core';

import { GainsightConfig } from '../../../models/gainsight.model';

declare let aptrinsic: (...args: unknown[]) => void;

@Injectable({
  providedIn: 'root',
})
export class GainsightService {
  InjectGainsight(
    tagKey: string,
    scriptSource: string = 'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
  ): void {
    const scriptName = 'aptrinsic';
    const existingAptrinsic = window[scriptName] as unknown;
    if (existingAptrinsic === undefined || existingAptrinsic === null) {
      (window[scriptName] as unknown) = ((...args: unknown[]) => {
        const aptrinsicObj = window[scriptName] as { q?: unknown[] };
        const queue =
          aptrinsicObj?.q !== undefined && aptrinsicObj?.q !== null
            ? aptrinsicObj.q
            : [];
        queue.push(...args);
        (window[scriptName] as { q: unknown[] }).q = queue;
      }) as unknown;
    }
    (window[scriptName] as { p: string }).p = tagKey;
    const newScript = document.createElement('script');
    newScript.async = true;
    newScript.src = `${scriptSource}?a=${tagKey}`;
    const scriptTags = document.getElementsByTagName('script')[0];
    if (scriptTags !== null && scriptTags !== undefined) {
      scriptTags?.parentNode?.insertBefore(newScript, scriptTags);
    } else {
      throw new Error('no scriptTag found');
    }
  }

  initGainsight(gainsightConfig: GainsightConfig): void {
    aptrinsic('identify', gainsightConfig.user, gainsightConfig.account);
  }
}
